import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=4e2740e6&scoped=true&"
import script from "./bankInfo.vue?vue&type=script&lang=js&"
export * from "./bankInfo.vue?vue&type=script&lang=js&"
import style0 from "./bankInfo.vue?vue&type=style&index=0&id=4e2740e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2740e6",
  null
  
)

export default component.exports